import React, { useEffect } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink
} from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import Cookies from 'js-cookie';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useStoreActions, useStoreState } from "easy-peasy";

import AcceptableUse from './AcceptableUse';
import ContactForm from './ContactForm';
import DomainList from './DomainList';
import BuyDomains from './BuyDomains';
import Home from './Home';
import ShortLinkolns from './ShortLinkolns';
import LinkolnEmails from './LinkolnEmails';
import Integrations from './Integrations';
import ForgotPassword from './ForgotPassword';
import UpdatePassword from './UpdatePassword';
import LogIn from './LogIn';
import LogOut from './LogOut';
import Privacy from './Privacy';
import SignUp from './SignUp';
import DemoSignUp from './DemoSignUp';
import DemoInstructions from './DemoInstructions';
import Terms from './Terms';
import VerifySignUp from './VerifySignUp';
import StartDemo from './StartDemo';
import '../App.css';


export default function App(props) {
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const domains = useStoreState(state => state.domains);
  const current_domain = useStoreState(state => state.current_domain);
  const getDomains = useStoreActions(actions => actions.domains.getDomains);
  const setCurrentDomain = useStoreActions(actions => actions.setCurrentDomain);
  const getUser = useStoreActions(actions => actions.user.getUser);
  const setIsLoggedIn = useStoreActions(actions => actions.setIsLoggedIn);


  function ToggleClass() {
     var element = document.getElementById("hamburger");
     element.classList.toggle("collapsed");
  }
  function ToggleClassShow() {
     var element = document.getElementById("nonUser");
     element.classList.toggle("show");
  }
  function ToggleClassUser() {
     var element = document.getElementById("hamburgerUser");
     element.classList.toggle("collapsed");
  }
  function ToggleClassShowUser() {
     var element = document.getElementById("userNav");
     element.classList.toggle("show");
  }

  useEffect(() => {
    console.log("IN USE EFFECT 1 - App.js")
    if (is_logged_in) {
      getUser();
      console.log("getting domains");
      getDomains();
      // getIntegrations();
    } else {
      console.log("Not logged in!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_logged_in]);

  useEffect(() => {
    console.log("IN USE EFFECT 2 - App.js")
      if (Cookies.get('name') && Cookies.get('is_logged_in')) {
        console.log("Setting logged in to true");
        setIsLoggedIn(true);
      }
  }, [setIsLoggedIn]);

  return (
    <Router basename={process.env.PUBLIC_URL}>
    {is_logged_in ? '' : (
    <header id="top" className="position-fixed w-100 shadow">
    <Navbar expand="lg" className="header">
      <div className="container">
        <a className="navbar-brand" href="/"><img src="images/LinkolnLogo.svg" className="logo" alt="Linkoln" /></a>
        <button id="hamburger" aria-controls="nonUser" type="button" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler collapsed" data-bs-toggle="collapse" data-bs-target="#nonUser">
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
        </button>
        <Navbar.Collapse id="nonUser" className="justify-content-end">
            <ul className="navbar-nav">
            <li className="nav-item my-2 my-lg-0">
              <NavLink onClick={function() { ToggleClass(); ToggleClassShow(); }} className="nav-link btn btn-danger text-white py-1 px-4 px-lg-3 mt-1 ms-lg-3 d-inline d-lg-block text-uppercase" to="/sign_up">Get Started</NavLink>
            </li>
            <li className="nav-item ml-lg-3 my-3 my-lg-0">
              <NavLink onClick={function() { ToggleClass(); ToggleClassShow(); }} className="nav-link btn btn-secondary text-white py-1 px-5 px-lg-4 mt-1 ms-lg-3 d-inline d-lg-block" to="/log_in">Login</NavLink>
            </li>
            </ul>
        </Navbar.Collapse>
      </div>
    </Navbar>
    </header>
    )}
  {is_logged_in ? (
    <header className="position-fixed w-100 shadow bg-white">
      <Navbar className="navbar-light" expand="lg">
        <div className="container">
          <Link className="navbar-brand" to="/"><img src="images/LinkolnLogo.svg" className="logo" alt="Linkoln" /></Link>
          <button id="hamburgerUser" aria-controls="userNav" type="button" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler collapsed" data-bs-toggle="collapse" data-bs-target="#userNav">
                  <span className="icon-bar top-bar"></span>
                  <span className="icon-bar middle-bar"></span>
                  <span className="icon-bar bottom-bar"></span>
          </button>
          {/*<Navbar.Toggle aria-controls="userNav"/>*/}
            <Navbar.Collapse id="userNav" className="justify-content-end p-md-0">
              {current_domain && ( <>
              <Nav className="mr-0">
                <NavDropdown to="/domain" title={"Domain: " + (current_domain ? current_domain.domain : "none")}>
                  {domains.good_domains && domains.good_domains.map(domain => (
                    <NavDropdown.Item key={domain.domain} active={current_domain.domain === domain.domain} to="/changedomain" onClick={(e) => {e.preventDefault(); setCurrentDomain(domain)}}>{domain.domain}</NavDropdown.Item>
                  ))}
                </NavDropdown>
              </Nav>
              <Nav>
                <NavDropdown as="div" title="Services">
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/short_linkolns">Short Linkolns</NavLink></NavDropdown.Item>
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/linkoln_emails">Linkoln Email</NavLink></NavDropdown.Item>
                </NavDropdown>
              </Nav>
              </>)}
              {false &&
              <Nav>
                <NavDropdown as="div" title="Domains">
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/account/domains">Domain list</NavLink></NavDropdown.Item>
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/account/purchase">Buy a domain</NavLink></NavDropdown.Item>
                </NavDropdown>
              </Nav>
              }
              <Nav>
                <NavDropdown as="div" title={Cookies.get('name')}>
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/update_password">Manage Password</NavLink></NavDropdown.Item>
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/logout">Log Out</NavLink></NavDropdown.Item>
                  <NavDropdown.Item><NavLink className="dropdown-item" onClick={function() { ToggleClassUser(); ToggleClassShowUser(); }} to="/contact_form">Contact us</NavLink></NavDropdown.Item>
                </NavDropdown>
              </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
      </header>
    ) : ''}

        <Switch>
          <Route path="/linkoln_emails">
            <div className="container mb-5 py-5 mt-5">
              <LinkolnEmails/>
            </div>
          </Route>
          <Route path="/short_linkolns">
            <div className="container mb-5 py-5 mt-5">
              <ShortLinkolns/>
            </div>
          </Route>
          <Route path="/privacy">
            <div className="container mb-5 pb-5 px-0">
              <Privacy/>
            </div>
          </Route>
          <Route path="/terms">
            <div className="container mb-5 px-0">
              <Terms/>
            </div>
          </Route>
          <Route path="/contact_form">
            <div className="container pb-5 mt-5">
              <ContactForm/>
            </div>
          </Route>
          <Route path="/account/integrations">
            <div className="container py-5 mt-5">
              <Integrations/>
            </div>
          </Route>
          <Route path="/logout">
            <div className="container py-5 mt-5">
              <LogOut/>
            </div>
          </Route>
          <Route path="/account/domains">
            <div className="container py-5 mt-5">
              <DomainList/>
            </div>
          </Route>
          <Route path="/account/purchase">
            <div className="container py-5 mt-5">
              <BuyDomains/>
            </div>
          </Route>
          <Route path="/sign_up">
            <div className="container py-5">
              <SignUp/>
            </div>
          </Route>
          <Route path="/demo_instructions">
            <div className="container py-5">
              <DemoInstructions/>
            </div>
          </Route>
          <Route path="/demo_sign_up">
            <div className="container py-5">
              <DemoSignUp/>
            </div>
          </Route>
          <Route path="/forgot_password">
            <div className="container py-5">
              <ForgotPassword/>
            </div>
          </Route>
          <Route path="/update_password/:code" key={document.location.href}>
            <div className="container py-5 mt-5">
              <UpdatePassword/>
            </div>
          </Route>
          <Route path="/update_password">
            <div className="container py-5 my-5">
              <UpdatePassword/>
            </div>
          </Route>
          <Route path="/start_demo/:code" key={document.location.href}>
            <div className="container py-5">
              <StartDemo/>
            </div>
          </Route>
          <Route path="/complete_signup/:code" key={document.location.href}>
            <div className="container py-5">
              <VerifySignUp/>
            </div>
          </Route>
          <Route path="/log_in">
            <div className="container py-5 mt-5">
              <LogIn/>
            </div>
          </Route>
          <Route path="/acceptableuse">
            <div className="container py-5">
              <AcceptableUse/>
            </div>
          </Route>
          <Route path="/">
            <Home/>
          </Route>
        </Switch>
        <footer className="position-relative bg-secondary text-white py-5">
            <HashLink to="#back2Top" ></HashLink>
            <div className="container">
                <div className="row">
                {!is_logged_in && false &&
                    <SignUp footer/>
                    }
                    <div className="col-md-3">
                        <h4 className="mb-4">Site Links</h4>
                        <ul className="menu list-unstyled">
                          <small>
                            <li><a href="/">Home</a></li>
                            {/*<li><Link to="/origin">Origin</Link></li>*/}
                            <li><Link to="/contact_form">Contact Us</Link></li>
                            {/*<li><Link to="/challenge">Challenge</Link></li>*/}
                            <li><Link to="/sign_up" className="text-uppercase">Get Started</Link></li>
                            <li><Link to="/log_in" >Login</Link></li>
                            <li><Link to="/privacy">Privacy</Link></li>
                            <li><Link to="/terms">Terms</Link></li>
                          </small>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </Router>
  );
}
